import type { ReactNode } from 'react';
import { View } from 'react-native';

import { useTenant } from '@/components/tenant-provider';
import { Text } from '@sixam/ui/text';

export function AdminModeHeader({
  actions,
  subtitle,
  title,
}: Readonly<{
  actions?: ReactNode;
  subtitle?: string | null;
  title: string;
}>) {
  const { activeTenant } = useTenant();

  return (
    <View className="gap-3 sm:flex-row sm:items-center sm:justify-between">
      <View className="min-w-0 flex-1 gap-1">
        <Text variant="h2" numberOfLines={2}>
          {title}
        </Text>
        <Text variant="muted" numberOfLines={1}>
          {subtitle ?? activeTenant?.name ?? 'Admin'}
        </Text>
      </View>
      <View className="flex-row flex-wrap items-center gap-2">{actions}</View>
    </View>
  );
}
